import request from '@/utils/request';

//登录
export const login = params => {
    return request({
        url: '/admin/login',
        method: 'post',
        data:params
    });
};
//获取登录用户信息
export const getUserInfo = () => {
    return request({
        url:'/admin/getUserInfo',
        method: 'get',
    });
};
//获取后台菜单列表
export const getBackstageMenuList = () => {
    return request({
        url:'/api/systemPermission/getUserByPermissionTree',
        method: 'get',
    });
};

//获取修改密码
export const editPsd = (data) => {
    return request({
        url:'/api/user/updateUserPassword',
        method: 'post',
				data
    });
};
